import Vue from 'vue';
import Login from './login/login.vue';
Vue.component('login', Login);
